import React from "react";
import {ToastAndroid , Platform} from "react-native";

const toast = ( msg)=>{
    if(Platform.OS == "android"){
        return ToastAndroid.showWithGravity(
            msg,
            ToastAndroid.LONG,
            ToastAndroid.BOTTOM,
        );
    }else{
        alert(msg);
    }
}

export default toast;